/**
 * Shared by the queries suspending into the single startup <Suspense> gate:
 * fire even offline, so a cold failure throws to Houston instead of hanging on
 * <Loading />. On reconnect, refetch unless the query sits on its terminal
 * error screen (errored with no data): a query still holding data, or reverted
 * by the rate-limit pause (query-client.ts), re-syncs.
 */
export const bootstrapGateNetworkOptions = {
  networkMode: "always",
  refetchOnReconnect: (query: { state: { data: unknown; error: unknown } }): boolean =>
    query.state.data !== undefined || query.state.error === null,
} as const;
